import { render, staticRenderFns } from "./FirmsSearch.vue?vue&type=template&id=487650e2"
import script from "./FirmsSearch.vue?vue&type=script&lang=js"
export * from "./FirmsSearch.vue?vue&type=script&lang=js"
import style0 from "./FirmsSearch.vue?vue&type=style&index=0&id=487650e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports